import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { cn } from "@/lib/utils";

type RouteFallbackProps = {
  label?: string;
  className?: string;
};

/** Full-viewport loader for Suspense / auth gates (avoids blank white screens). */
export function RouteFallback({ label = "Loading...", className }: RouteFallbackProps) {
  return (
    <div
      className={cn(
        "flex min-h-[50vh] w-full flex-1 items-center justify-center bg-background px-4",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <LoadingLogo label={label} />
    </div>
  );
}
